import { Link } from 'react-router-dom';

interface Brand {
  id: number;
  name: string;
  logo_url?: string;
  country?: string;
  description?: string;
  product_count?: number;
}

interface BrandCardProps {
  brand: Brand;
}

const BrandCard = ({ brand }: BrandCardProps) => {
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <Link
      to={`/products?brand=${brand.id}`}
      className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
    >
      {/* Logo or Placeholder */}
      <div className="w-full aspect-square mb-4 flex items-center justify-center bg-gray-50 rounded-lg overflow-hidden">
        {brand.logo_url ? (
          <img
            src={brand.logo_url}
            alt={brand.name}
            className="w-full h-full object-contain p-4"
          />
        ) : (
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center">
            <span className="text-2xl font-bold text-white">
              {getInitials(brand.name)}
            </span>
          </div>
        )}
      </div>

      {/* Brand Name */}
      <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors line-clamp-2">
        {brand.name}
      </h3>

      {/* Country (if available) */}
      {brand.country && (
        <div className="flex items-center gap-1.5 text-sm text-gray-500 mb-2">
          <i className="ri-map-pin-line text-base"></i>
          <span>{brand.country}</span>
        </div>
      )}

      {/* Product Count */}
      <div className="flex items-center justify-between pt-3 border-t border-gray-100">
        <span className="text-sm text-gray-600">
          {brand.product_count || 0} product{brand.product_count !== 1 ? 's' : ''}
        </span>
        <i className="ri-arrow-right-line text-lg text-gray-400 group-hover:text-blue-600 group-hover:translate-x-1 transition-all"></i>
      </div>
    </Link>
  );
};

export default BrandCard;
